import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LibOptionValue } from "daisy-design-system-front";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormControl } from "@angular/forms";
import { DropdownComponent } from "@gnv-shared/components";
import { ReportFrequency } from "../../../../../swagger-gen/web-secured/models/report-frequency";

@Component({
  selector: "app-recurrency",
  standalone: true,
  imports: [CommonModule, DropdownComponent, TranslateModule],
  templateUrl: "./recurrency.component.html",
  styleUrls: ["./recurrency.component.scss"],
})
export class RecurrencyComponent implements OnInit {
  @Input() valueFormControl = new FormControl<ReportFrequency | null>(null);

  public options: LibOptionValue<ReportFrequency>[] = [];

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    this.options = Object.values(ReportFrequency).map((item) => ({
      value: item,
      label: this.translateService.instant(`export-creation.form.recurrence.${item.toLowerCase()}`)
    }));
  }
}
